import { useEffect } from "react";
import FormContainer from "../components/FormContainer";
import Logo from "../components/Logo";
import useMktWeb from "../hooks/useMktWeb";
import { useTheme } from "../hooks/useTheme";

export default function RedirectPage() {

    const { theme } = useTheme();
    const { getNextWhatsapp } = useMktWeb();

    useEffect(() => {
        getNextWhatsapp(theme.phone).then(phoneRedirect => {
            window.location.href = `https://wa.me/${phoneRedirect}`;
        });
    }, [getNextWhatsapp, theme.phone]);

    return (
        <div className="w-full h-screen flex justify-content-center background" style={{ backgroundImage: theme.background.path }}>
            <div className='p-4' style={{ maxWidth: 450 }}>
                <center className='pb-6 pt-4'>
                    <Logo/>
                </center>
                <FormContainer>
                    <img src="/img/whatsapp.svg" width={17} style={{ marginRight: 10 }} alt=""/>
                    Redirecionando...
                </FormContainer>
            </div>
        </div>
    );
}